import { invokeApi } from "../utils/api";
import { $axios } from "../utils/axios";

export const subDealerContact = () =>
	invokeApi($axios, "/subdealer/contact", {}, "GET")
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});

export const subDealerSingleContact = (id, softdelete) =>
	invokeApi(
		$axios,
		`/subdealer/contact/${softdelete === "true" ? "soft-delete/" : ""}${id}`,
		{},
		"GET"
	)
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});

export const softDeleteSubDealerSingleContact = (id, reason) =>
	invokeApi($axios, `/subdealer/contact/soft-delete/${id}?reason=${reason}`, {}, "DELETE")
		.then((resp) => resp)
		.catch((err) => {
			throw err;
		});
